import React, { useEffect, useState } from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import { sendEmail } from './contact';

const LandingPage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="app">
      {/* Header */}
      <header className={`app-header ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-content">
          <img
            src={`${process.env.PUBLIC_URL}/assets/retailx.png`}
            alt="RetailX"
            className="header-logo"
          />
          <div className="header-buttons">
            <Link to="/jobs">
              <button className="contact-button">Jobs</button>
            </Link>
            <button className="contact-button primary" onClick={sendEmail}>
              Contact Us
            </button>
          </div>
        </div>
      </header>

      <main className="main-content">
        <h1 className="investments-title">Our products</h1>
        <div className="cards-container">

          <a href="https://lyftis.se" target="_blank" rel="noopener noreferrer">
            <div className="card">
              <img src={`${process.env.PUBLIC_URL}/assets/lyftis.png`} alt="Lyftis Logo" className="card-image" />
              <div className="card-content">
                <h3>Lyftis - AI for marketing for restaurants</h3>
              </div>
            </div>
          </a>

          <a href="https://kollis.se/solution" target="_blank" rel="noopener noreferrer">
            <div className="card">
              <img src={`${process.env.PUBLIC_URL}/assets/kollis.png`} alt="Kollis Logo" className="card-image" />
              <div className="card-content">
                <h3>Kollis - All-in daily operations for restaurants and cafés</h3>
              </div>
            </div>
          </a>

          <a href="https://caterflow.se/losning" target="_blank" rel="noopener noreferrer">
            <div className="card">
              <img src={`${process.env.PUBLIC_URL}/assets/caterflow.png`} alt="CaterFlow Logo" className="card-image" />
              <div className="card-content">
                <h3>CaterFlow - B2B ordering portal for catering suppliers</h3>
              </div>
            </div>
          </a>

        </div>
      </main>

      <footer className="app-footer">
        <div className="footer-content">
          <span className="copyright-text">© 2026 RetailX. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
